import React from "react"
import SectionDivider from "../shared/section-divider"
import { useStaticQuery, graphql } from "gatsby"
import {
  Container,
  SectionTitle,
  TitleContainer,
} from "./additional-features.style"
import { T } from "../shared/typography.styles"
import styled from "styled-components"

import FeatureGrid from "../../design-system/organisms/feature-grid"
import Grid from "../shared/grid"
import Breakpoints from "../shared/breakpoints"

import FadedTitle from "../shared/faded-title"
import { FadeInBottom } from "../../design-system/styles/animations.styles"
import { Link } from "react-scroll"

export const ContactFormLink = styled(Link)`
  ${T.lg.h3.bold}
  grid-column: 1 / -1;
  cursor: pointer;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 11px;
  min-height: 46px;
  justify-self: center;
  justify-content: center;
  align-items: center;
  text-align: center;
  letter-spacing: 0.2em;
  min-width: 282px;
  width: 282px;
  background-color: var(--burnt-orange);
  color: var(--white);
  padding: 16px 48px;
  display: inline-block;
  border: none;
  outline: none;
  margin-top: 32px;

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 64px;
    width: unset;
    min-width: unset;
  }
`

export default function AdditionalFeatures() {
  const query = useStaticQuery(graphql`
    query {
      hardwareIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Desktop/icons/hardware_icon.svg"
        }
      ) {
        publicURL
      }
      languagesIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Desktop/icons/languages_icon.svg"
        }
      ) {
        publicURL
      }
      offlineIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Desktop/icons/offline_icon.svg"
        }
      ) {
        publicURL
      }
      uptimeIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Desktop/icons/uptime_icon.svg"
        }
      ) {
        publicURL
      }
      directoryFade: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Desktop/fade_titles/directory title dark.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  const GridItems = [
    {
      icon: query.hardwareIcon.publicURL,
      title: "Hardware Agnostic",
      text: `Mappedin’s Digital Directory software works with a variety of
            hardware types regardless of orientation, screen size, or
            resolution. And, while we don’t sell hardware, we’re happy to
            recommend one of Mappedin’s preferred partners to make your
            purchasing process seamless.`,
    },
    {
      icon: query.offlineIcon.publicURL,
      title: "Offline Mode",
      text: `Our Digital Directory is fully functional while offline, ensuring
            that visitors can find what they’re looking for even if you don't
            have a connection. Once connected, your directory will pull updates
            made to your map and the Digital Directory.`,
    },
    {
      icon: query.uptimeIcon.publicURL,
      title: "24/7 Support",
      text: `With a support team available around the clock and automated
            monitoring in place, our team can quickly address any directory
            issues.`,
    },
    {
      icon: query.languagesIcon.publicURL,
      title: "Multiple Languages",
      text: `Mappedin’s products have been deployed globally and we strive to
            support as many languages as possible. If we don't have the language
            you need, we will add it.`,
    },
  ]

  return (
    <>
      <SectionDivider />
      <Container>
        <Grid.Animated animated={FadeInBottom} delay="0.25s">
          <TitleContainer>
            <FadedTitle
              title="Additional Features"
              image={query.directoryFade.publicURL}
              alt="Directory"
              fadeSettings={{
                lg: "center",
              }}
              textAlign="center"
            />
          </TitleContainer>
          <FeatureGrid.Animated
            animated={FadeInBottom}
            delay="0.25s"
            items={GridItems}
          />
          <ContactFormLink to="contact-form" smooth duration={1000}>
            Book a Demo
          </ContactFormLink>
        </Grid.Animated>
      </Container>
      <SectionDivider flip />
    </>
  )
}
